export const getCustomerDocumentPath = (document) => document?.file_url || document?.url || '';

export const getCustomerDocumentUrl = (documentOrPath) => {
  if (!documentOrPath) return '';
  if (typeof documentOrPath === 'string') return documentOrPath;
  return getCustomerDocumentPath(documentOrPath);
};

export const isCustomerPhotoDocument = (document) => {
  const type = document?.document_type;
  return type === 'photo' || type === 'customer_photo';
};

export const isImageCustomerDocument = (document) => {
  const mimeType = document?.mime_type || '';
  const documentPath = getCustomerDocumentPath(document);

  return mimeType.startsWith('image/') || /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(documentPath);
};
